<div class="skeleton"></div>

<style>
  .skeleton {
    width: 100%;
    height: 1rem;
    background: rgba(0, 0, 0, 0.11);
    border-radius: 1px;
    overflow: hidden;
    animation: skeleton-animation 1.5s ease-in-out 0.5s infinite;
  }

  @keyframes skeleton-animation {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
    100% {
      opacity: 1;
    }
  }
</style>
